import React from "react";
import * as PIXI from 'pixi.js'
import {Paper,Grid,Button,Typography} from "@material-ui/core";
import { withStyles } from '@material-ui/styles';
import initialCodes from "../constants/initialCodes";
window.PIXI = PIXI;

const styles = {
    root: {
        background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        border: 0,
        borderRadius: 3,
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        color: 'white',
        height: 48,
        padding: '0 30px',
    },
    textArea:{
        width: '99%',
        resize: 'none',
        height: 590,
        float: 'top',
        minHeight: 250,
        overflow: 'scroll',
        margin: 'auto',
        display: 'inline-block',
        background: '#f0c98b',
        outline: 'none',
        fontFamily: 'Courier, sans-serif',
        fontSize: 14
    },
    runButton: {
        marginRight: 5
    },
    canvas: {
        marginTop: 5
    }
};

// Performance Label Elements
const pixiPerformanceLabel = document.createElement('P');
const canvasPerformanceLabel = document.createElement('P');

// Pixi Elements (Do not remove even if your ide says unused variable!)
let app = new PIXI.Application({width:600,height:600,antialias: true});
let CENTER_X = app.view.width/2;
let CENTER_Y = app.view.height/2;
let graphics = new PIXI.Graphics();

// Canvas Elements
let canvas = document.createElement('canvas');

const drawPixi = () => {
    const pixiTextArea = document.getElementById('pixiTextArea');
    const pixiCanvas = document.getElementById('pixi');
    while (pixiCanvas.firstChild) {
        pixiCanvas.firstChild.remove();
    };
    const t0 = performance.now();
    pixiTextArea && eval(pixiTextArea.value);

    pixiCanvas.prepend(app.view);
    const t1 = performance.now();
    pixiPerformanceLabel.innerText = 'It took ' + (t1-t0) + 'ms';
    pixiCanvas.appendChild(pixiPerformanceLabel);
};

const drawCanvas = () => {
    const canvasTextArea = document.getElementById('canvasTextArea');
    const canvasDomElement = document.getElementById('canvas');
    while (canvasDomElement.firstChild) {
        canvasDomElement.firstChild.remove();
    };
    const t0 = performance.now();
    canvasTextArea && eval(canvasTextArea.value);

    canvasDomElement.prepend(canvas);
    const t1 = performance.now();
    canvasPerformanceLabel.innerText = 'It took ' + (t1-t0) + 'ms';
    canvasDomElement.appendChild(canvasPerformanceLabel);
};

class Playground extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            num: 1
        }
    }

    render(){
        const { classes } = this.props;
        const {pixi, canvas} = initialCodes;
        return(
            <div>
                <Paper >
                    <Grid container>
                        <Grid item xs={6} >
                            <Grid container style={{backgroundColor:'#bdb7b7'}} direction="column">
                                <Grid item>
                                    <Typography >
                                        PixiJS Code Area:
                                    </Typography>
                                    <textarea spellCheck="false" autoComplete="off" className={classes.textArea} id="pixiTextArea">{pixi}</textarea>
                                </Grid>
                                <Grid item align='right'>
                            <Button className={classes.runButton} onClick={drawPixi} variant="contained" color="primary">Run</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} align="center" style={{backgroundColor:'#f57171'}}>
                            <div className={classes.canvas} id="pixi">
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
                <Paper style={{marginTop:5}} >
                    <Grid container>
                        <Grid item xs={6} >
                            <Grid container style={{backgroundColor:'#bdb7b7'}} direction="column">
                                <Grid item>
                                    <Typography >
                                        Canvas Code Area:
                                    </Typography>
                                    <textarea spellCheck="false" autoComplete="off" className={classes.textArea} id="canvasTextArea">{canvas}</textarea>
                                </Grid>
                                <Grid item align='right'>
                                    <Button className={classes.runButton} onClick={drawCanvas} variant="contained" color="primary">Run</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} align="center" style={{backgroundColor:'#f57171'}}>
                            <div className={classes.canvas} id="canvas">
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        )
    }

    componentDidMount() {
        document.getElementById('pixi').appendChild(app.view);
        const ctx = canvas.getContext('2d');
        canvas.width = 600;
        canvas.height = 600;
        ctx.fillStyle = "black";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        document.getElementById('canvas').appendChild(canvas);
    }
}


export default withStyles(styles)(Playground);